import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/[0.02] p-8">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-gold/20 bg-gold/[0.06]">
            <Lock className="h-6 w-6 text-gold-light" />
          </div>
          <h1 className="text-xl font-medium text-white">Yönetim Paneli</h1>
          <p className="mt-1 text-sm text-slate-400">Content House TR</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email" className="text-slate-300">E-posta</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-white/5 border-white/10 text-white"
              data-testid="admin-login-email-input"
              required
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-slate-300">Şifre</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-white/5 border-white/10 text-white"
              data-testid="admin-login-password-input"
              required
            />
          </div>

          {error && (
            <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>
          )}

          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-gold text-black hover:bg-gold-light"
            data-testid="admin-login-submit-button"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Giriş Yap"}
          </Button>
        </form>
      </div>
    </div>
  );
}
